import React from 'react'

function RestartIcon() {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="25.000000pt" height="25.000000pt" viewBox="0 0 167.000000 157.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,157.000000) scale(0.100000,-0.100000)"
                fill="#78c3ae" stroke="none" >
                <path d="M695 1466 c-131 -31 -227 -75 -313 -144 l-43 -35 -67 66 c-71 71 -98
                81 -130 49 -17 -17 -18 -38 -18 -241 1 -221 2 -223 25 -242 21 -17 42 -19 235
                -19 175 0 215 3 234 16 41 28 29 61 -50 141 l-71 71 63 41 c75 49 141 71 231
                78 286 23 536 -243 492 -525 -21 -134 -97 -252 -207 -324 -160 -104 -352 -103
                -513 1 -33 21 -73 55 -89 75 -16 20 -36 36 -44 36 -21 0 -150 -131 -150 -152
                0 -26 133 -142 207 -181 119 -62 201 -82 338 -81 101 0 132 4 197 26 117 39
                204 92 289 177 85 85 134 166 175 286 23 69 27 96 27 200 0 104 -4 130 -27
                200 -41 120 -90 201 -175 286 -129 128 -282 196 -461 204 -61 3 -116 0 -155
                -9z"/>
            </g>
        </svg>
    )
}

export default RestartIcon